import { Typography } from 'antd';

/**
 * Placeholder honesto para métricas que el contrato declara opcionales pero que el
 * backend aún no publica (historial de sesiones, US 2.9). Muestra `—` en vez de forzar `0`
 * —que afirmaría un valor falso— y expone la nota en el `title`/`aria-label` para no
 * dejar al lector adivinando.
 */
export function PendingMetric({
  note = 'Pendiente US 2.9 (historial de sesiones).',
}: {
  note?: string;
}) {
  return (
    <Typography.Text type="secondary" title={note} aria-label={note}>
      —
    </Typography.Text>
  );
}
